module.exports = __webpack_public_path__ + "media/images/Groupe 178-5b901bd3253a6c2e988b3c9614e0009d.svg";